import {useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {updateAppSettings} from '../../settings/settingsSlice'

import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import css from './Styles.module.css'

export default function Tax () {
	const dispatch = useDispatch()
	const percent = useSelector(
		state => state.settings.app.tax_percent
	)
	const [newPercent,setNewPercent] = useState()
	const [isSaving,setIsSaving] = useState(false)
	const handleSave = () => {
		setIsSaving(true)
		dispatch(updateAppSettings({
			tax_percent: parseFloat(newPercent) || 0
		})).then(()=>{
			setIsSaving(false)
		})
	}

	return (
		<div>
			<strong className="d-block">
				Tax Percentage
			</strong>
			<InputGroup>
				<Form.Control
					onChange={e=>{
						setNewPercent(e.target.value)
					}}
					defaultValue={percent || ''}
					placeholder="Percent"
				/>
				<InputGroup.Append>
					<Button 
						onClick={handleSave}
						variant="outline-success"
					>
						Save {isSaving&&<Spinner animation="border" size="sm"/>}
					</Button>
				</InputGroup.Append>
			</InputGroup>
			<small className="d-block">
				<i className="fa fa-info-circle mr-1"/>
				This is the tax percent to charge on all products/services
			</small>
		</div>
	)
}








